import { isNil, isEmpty } from "../Helper";
import { loadStorageData, saveStorageData } from "../Services/LocalStorage";
const VALUE_PATH = "module.configuration";
export default class Tree {
    constructor(_root) {
        this.root = _root;
        this.type = this.root.getAttribute("data-type");
        this.treeBranchStates = this.loadTreeBranchStates(true);
        this.nodes = Array.from(this.root.querySelectorAll(".neos-tree-node"));
        this.initializeTree();
        this.setupEventListeners();
    }
    initializeTree() {
        this.nodes.forEach((_node) => {
            if (_node.firstChild.nodeName.toLowerCase() !== "ul") {
                // @ts-ignore
                this.wrapElementWithNodeTitle(_node.firstChild);
            }
            const hasSubnodes = _node.querySelectorAll(".neos-tree-node");
            if (this.isFolder(_node) &&
                !isNil(hasSubnodes) &&
                hasSubnodes.length > 0) {
                const expandIcon = this.createExpandIcon();
                _node.insertBefore(expandIcon, _node.firstChild);
            }
        });
    }
    initializeTreeState(items) {
        if (!Array.isArray(items)) {
            return;
        }
        items.forEach((_item) => {
            const node = this.root.querySelector(`[title="${_item}"`);
            if (!isNil(node)) {
                node.classList.add("neos-tree-open");
            }
        });
    }
    setupEventListeners() {
        this.nodes.forEach((_node) => {
            _node.addEventListener("click", this.onNodeClick.bind(this));
        });
    }
    onNodeClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const target = event.target;
        const node = target.closest(".neos-tree-node");
        if (!isNil(node)) {
            this.deselectCurrentActiveNode();
            node.classList.toggle("neos-tree-active");
        }
        if (this.isFolder(node)) {
            this.toggle(node);
        }
    }
    deselectCurrentActiveNode() {
        this.root.querySelectorAll(".neos-tree-active").forEach((_node) => {
            _node.classList.remove("neos-tree-active");
        });
    }
    createExpandIcon() {
        const expandIcon = document.createElement("span");
        expandIcon.classList.add("neos-tree-expander");
        return expandIcon;
    }
    wrapElementWithNodeTitle(element) {
        const nodeTitle = document.createElement("span");
        nodeTitle.classList.add("neos-tree-title");
        element.parentNode.insertBefore(nodeTitle, element);
        nodeTitle.appendChild(element);
    }
    isFolder(node) {
        return !isNil(node) && node.classList.contains("neos-tree-folder");
    }
    toggle(node) {
        node.classList.toggle("neos-tree-open");
        this.changeTreeBranchState(node.getAttribute("title"));
    }
    getPathForType() {
        const path = VALUE_PATH + (!isEmpty(this.type) ? "." + this.type : "");
        return path.toLowerCase();
    }
    loadTreeBranchStates(init) {
        const pathWithType = this.getPathForType();
        const storageData = loadStorageData(pathWithType);
        if (!isNil(init) && init === true) {
            this.initializeTreeState(storageData);
        }
        this.treeBranchStates = Array.isArray(storageData) ? storageData : [];
        return this.treeBranchStates;
    }
    saveTreeBranchStates() {
        const pathWithType = this.getPathForType();
        if (Array.isArray(this.treeBranchStates)) {
            saveStorageData(pathWithType, this.treeBranchStates);
        }
    }
    changeTreeBranchState(path) {
        if (isEmpty(path) || !Array.isArray(this.treeBranchStates)) {
            return;
        }
        if (this.treeBranchStates.includes(path)) {
            this.treeBranchStates = this.treeBranchStates.filter((item) => item !== path);
        }
        else {
            this.treeBranchStates.push(path);
        }
        this.saveTreeBranchStates();
    }
}
